import t from "../../../helpers/t";
import React from "react";

const InsuranceCertificatesPanel = (props) => {
  const { insurance } = props;
  return (
    <>
      <div className={"inb-contingent-progress"} style={{ marginBottom: "-1rem" }}>
        <>
          <div
            className="progress beautify"
            role="progressbar"
            tabIndex="0"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuetext="50 percent"
            aria-valuemax="100"
          >
            <div className="progress-bars">
              {/*<span className="progress-meter" style={{width: "100%"}}> </span>*/}
            </div>
            <p className="progress-meter-text">
              {insurance.insurance_certificates.length + " " + t("certificates", null, "capital")}
            </p>
          </div>
        </>
      </div>
    </>
  );
};
export default InsuranceCertificatesPanel;
